import * as z from "zod/v4";

export const disableContextual = {
  name: "disableContextual" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
